import React, { useContext, useState } from 'react'
import { AppContext } from '../../../App'
import QuoteActionLinks from '../../QuoteActionLinks'
import QuoteModals from '../../QuoteModals'
import { CustomToggleShoppingCart } from '../resinous/resinousFormInputs'
import { Formik, Form } from 'formik'
import $ from 'jquery'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import config from '../../../config.json'
import axios from 'axios'
import toastNotify from '../../../services/toastNotify'
import Loading from '../../loading'
import ResinousAddToCartModal from '../resinous/ResinousAddToCartModal'

export default function UnderlaymentQuoteCreated() {
   const {
       coverageDetails,
       coverageData,
       unit,
       unitForDisplayOnly,
       unitCount,
       sku,
       productSelected,
      productOptionsSelected,
   } = useContext(AppContext)

    const [addToCartError, setAddToCartError] = useState(false)
   const { productOptions } = productOptionsSelected
   const { totalArea } = coverageDetails.formData
   const productType = productOptions[1]
    const productName = productOptions[2]
    const iconCartPlus = <FontAwesomeIcon icon={faCartPlus} color="#00a8d5" />

    // Handle "Add to Cart" button click.
    const handleAddToCart = (values) => {
        setAddToCartError(false)

        var arr = [];
        Object.keys(values).forEach(function (key) {
            if (values[key]) {
                arr.push(key);
            }
        });

        // Prepare the data from the form of items selected to add to cart
        const productNamesSkusQuantitiesRaw = arr
        let productNamesSkusQuantities = productNamesSkusQuantitiesRaw.map(p => {
            return p.split(',')
        })

        let productSkus = productNamesSkusQuantities.map(p => p[0])
        let productQuantities = productNamesSkusQuantities.map(p => p[1])

        let uomsArray = productNamesSkusQuantities.map(p => "EA")

        let dataForCart = {
            "Items": [...productSkus],
            "UOMs": [...uomsArray],
            "Quantities": [...productQuantities],
            "ItemNumberIsShortItemNumber": false
        }

        productSkus = []
        productQuantities = []
        uomsArray = []

        function callCart(dataForCart) {
            //Clear the cart
            $.ajax({
                type: "POST",
                dataType: "json",
                xhrFields: { withCredentials: true },
                url: "https://my.laticrete.com/ECO/Services/scShoppingProcess/ClearShoppingCart",
                success: function (data) {
                    // const message = "Success! Shopping cart is now cleared."
                    // const type = "success"
                    // toastNotify(message, type)
                },
                error: function (xhr, error) {
                    setAddToCartError("There was a problem adding to cart.")
                    const message = "Error. Shopping cart could not be cleared."
                    const type = "error"
                    toastNotify(message, type)
                }
            }).done(function () {
                // Send product data object to the cart
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    xhrFields: { withCredentials: true },
                    data: dataForCart,
                    url: "https://my.laticrete.com/ECO/Services/scShoppingProcess/AddItemsToCart",
                    success: function () {
                        const message = "Success! Cart has been updated with new items."
                        const type = "success"
                        toastNotify(message, type)
                    },
                    error: function () {
                        setAddToCartError("There was a problem adding to cart.")
                        const message = "Error. Items could not be added to cart."
                        const type = "error"
                        toastNotify(message, type)
                    }
                }).done(function (response) {
                    const message = "Items added to cart. Redirecting to my.laticrete.com."
                    const type = "success"
                    toastNotify(message, type)
                    window.location.href = "https://my.laticrete.com/shopping-cart";
                })
            }).fail(function () {
                setAddToCartError("There was a problem adding to cart.")
            })
        }

        // Ensure product(s) are selected then send to cart. If not, throw error.
        Object.values(values).includes(true) ? (
            callCart(dataForCart)
            // SAMPLE DATA STRUCTURE
            // {
            //     "Items":["9140-0002-2","9302-0055-2","9236-0001-22","9811-0005-2","9807-0005-2"],
            //     "UOMs":["EA","EA","EA","EA","EA"],
            //     "Quantities":["5","4","2","2","2"],
            //    "ItemNumberIsShortItemNumber":false
            // }
        ) : (
            setAddToCartError("No products selected. Please select products.")
        )
    }
 

   return (
      <React.Fragment>
      <div className="col-xs-12">
         <h3>Coverage Details</h3>
         <div className="data-table">
            <div className="row hidden-xs">
                       <div className="col-xs-12 col-sm-4">Total Area</div>
                       <div className="col-xs-12 col-sm-4">{
                           (coverageData && coverageData.thicknessCoverageText !== undefined) ? "Thickness" : ""
                       }</div>
                       <div className="col-xs-12 col-sm-4">{
                           (coverageData && coverageData.colorText !== undefined) ? "Color" : ""
                       }</div>
            </div>
            <div className="row p-1">
               <div className="col-xs-12">
                  <div className="row p-1">
                     <div className="col-xs-6 visible-xs">
                        <strong>Total Area: </strong>
                     </div>
                     <div className="col-xs-6 col-sm-4">
                        { totalArea }{ unit==="sqft" ? "ft\u00B2" : "m\u00B2" }
                               </div>
                               <div className="col-xs-6 visible-xs">
                                   (coverageData && coverageData.thicknessCoverageText !== undefined) ? "<strong>Thickness:</strong>" : ""
                                   
                               </div>
                               <div className="col-xs-6 col-sm-4"> 
                                   {
                                       (coverageData && coverageData.thicknessCoverageText !== undefined) ? coverageData.thicknessCoverageText : ""
                                   }
                        </div>
                               <div className="col-xs-6 visible-xs">
                                   (coverageData && coverageData.colorText != undefined) ? "<strong>Color:</strong>" : ""
                                   
                               </div>
                               <div className="col-xs-6 col-sm-4">
                                   {
                                       (coverageData && coverageData.colorText != undefined) ? coverageData.colorText : ""
                                   }
                               </div>
                  </div>
               </div>
            </div>
         </div>
         <h3>Supplies</h3>

               <Formik initialValues={{}} onSubmit={(values) => { handleAddToCart(values) }} >
                   {
                       props => (
                           <Form>

               <div className="data-table">
                   <div className="row hidden-xs">
                       <div className="col-xs-12 col-sm-2">Item/Sku #</div>
                       <div className="col-xs-12 col-sm-2">Coverage</div>
                       <div className="col-xs-12 col-sm-2">Unit Size</div>
                       <div className="col-xs-12 col-sm-2">Required Amount</div>
                       <div className="col-xs-12 col-sm-2">Suggested Quantity</div>
                                       {productSelected.isSoldOnline == "true" &&
                                           <div className="col-xs-12 col-sm-2 hidden-print">Add to Cart</div>
                                       }
                   </div>
                   {
                       // Create a table row for each product.
                       
                               // BEGIN PRODUCT ROW
                               <div className="row p-1">
                                   <div className="col-xs-12 col-sm-2">
                                       <div className="row p-1">
                                           <div className="col-xs-6 visible-xs">
                                               <strong>Item/Sku #:</strong>
                                           </div>
                                   <div className="col-xs-6 col-sm-12">
                                       {
                                           (coverageData && coverageData.colorSku) ? coverageData.colorSku : productSelected.sku
                                           
                                       }
                                           </div>
                                       </div>
                                   </div>
                                   <div className="col-xs-12 col-sm-2">
                                       <div className="row p-1">
                                           <div className="col-xs-6 visible-xs">
                                               <strong>Coverage:</strong>
                                           </div>
                                   <div className="col-xs-6 col-sm-12">
                                       {
                                           (coverageData && coverageData.coverage) ? coverageData.coverage + " " : ""
                                               }



                                       {unit} per unit
                                           </div>
                                       </div>
                                   </div>
                                   <div className="col-xs-12 col-sm-2">
                                       <div className="row p-1">
                                           <div className="col-xs-6 visible-xs">
                                               <strong>Unit Size:</strong>
                                           </div>
                                           <div className="col-xs-6 col-sm-12">
                                       { // "UNIT SIZE"
                                           unitForDisplayOnly || `${productSelected.unitCount} ${productSelected.unit} ${productSelected.containerType}`
                                       }
                                           </div>
                                       </div>
                                   </div>
                                   <div className="col-xs-12 col-sm-2">
                                       <div className="row p-1">
                                           <div className="col-xs-6 visible-xs">
                                               <strong>Required Amount:</strong>
                                           </div>
                                           <div className="col-xs-6 col-sm-12">
                                               {  
                                           (coverageData) ? coverageData.unitsRequiredDefault : ""
                                                   
                                               }
                                               {" units"}
                                           </div>
                                       </div>
                                   </div>
                                   <div className="col-xs-12 col-sm-2">
                                       <div className="row p-1">
                                           <div className="col-xs-6 visible-xs">
                                               <strong>Suggested Quantity:</strong>
                                           </div>
                                           <div className="col-xs-6 col-sm-12">
                                               {
                                                   // "SUGGESTED QUANTITY"
                                           (coverageData) ? coverageData.actualUnitsRequiredDefault : ""
                                               }
                                           </div>
                                       </div>
                                           </div>
                                           { productSelected.isSoldOnline == "true" &&
                                               <div className="col-xs-12 col-sm-2 hidden-print">
                                                   <div className="row p-1">
                                                       <div className="col-xs-6 visible-xs">
                                                           <strong>Add to cart:</strong>
                                                       </div>
                                                       <div className="col-xs-6 col-sm-12">
                                                           {
                                                               <CustomToggleShoppingCart
                                                                   name={
                                                                       [(coverageData && coverageData.colorSku) ? coverageData.colorSku : productSelected.sku, (coverageData) ? coverageData.actualUnitsRequiredDefault : ""]
                                                                   }
                                                               />
                                                           }

                                                       </div>
                                                   </div>
                                               </div>
                                           }
                               </div>

                   }
                               </div>
                               { productSelected.isSoldOnline == "true" &&
                                   <div className="row hidden-print">
                                       <div className="col-xs-12 col-sm-4 col-sm-push-8 col-lg-3 col-lg-push-9">
                                           {
                                               // productsSelected.length > 0 ? (
                                               <button type="submit" className="btn btn-primary btn-lg btn-block btn-add-to-cart" data-bs-toggle="modal" data-bs-target="#modal-addToCart" >{iconCartPlus} ADD TO CART</button>
                                               // ) : (
                                               // <button type="submit" className="btn btn-primary btn-lg btn-block btn-add-to-cart" disabled>{ iconCartPlus } SELECT PRODUCTS</button>
                                               // )
                                           }
                                       </div>
                                   </div>
                               }
                           </Form>
                       )}
               </Formik>

         <div className="row p-1">
            <QuoteActionLinks productType={ productType } />
               </div>
               <ResinousAddToCartModal error={addToCartError} />
         <QuoteModals />
      </div>
      </React.Fragment>
   )
}





// WEBPACK FOOTER //
// ./src/components/productTypes/underlayment/UnderlaymentQuoteCreated.js